import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { Schedule } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddSchedule = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (schedule: Partial<Schedule>) => add<Schedule>("schedules", schedule),
    {
      onSuccess: (schedule) => {
        enqueueSnackbar("Schedule Added Success", { variant: "success" });
        queryClient.setQueryData<Schedule[]>(
          [RQ.SCHEDULES],
          (schedules: Schedule[] | undefined) => {
            return [...(schedules ?? []), schedule];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Schedule Adding Error", { variant: "error" });
      },
    }
  );
};
